import { Component, HostListener, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { MatDialog, MatIconRegistry } from '@angular/material'
import { filter, take, takeUntil } from 'rxjs/operators'

import { AppState } from './store'
import * as fromAuth from './shared/auth/store'
import * as fromChat from './chat/store'
import * as fromConvTeam from './shared/team'

import { NotificationService } from './shared/notifications/notification.service'
import { CommonComponent } from './shared/common.component'
import { FaviconService } from './shared/favicon/favicon.service'
import { OfflineDialogComponent } from './offline-dialog.component'
import { SignalRService } from './shared/signalR'
import { DomSanitizer } from '@angular/platform-browser'
import { appIcons } from './app.icons'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends CommonComponent implements OnInit {
  loggedIn$ = this.rootStore.select(fromAuth.getAuthLoggedIn)
  options: any
  offlineDialog
  isOnline = true

  constructor(private store: Store<fromChat.ChatState>,
              private rootStore: Store<AppState>,
              private notificationService: NotificationService,
              private dialog: MatDialog,
              private signalRService: SignalRService,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer) {
    super()

    appIcons.forEach(icon =>
      iconRegistry.addSvgIcon(
        icon,
        sanitizer.bypassSecurityTrustResourceUrl(`assets/img/${icon}.svg`))
    )
  }

  ngOnInit(): void {
    this.signalRService.startConnection()

    this.options = this.notificationService.getNotificationsOptions()

    // fires only once when app starts and only if user was loggedIn previously (rehydrated)
    this.loggedIn$.pipe(
      filter(_ => _),
      take(1))
      .subscribe(_ => this.store.dispatch(new fromAuth.MeRefresh()))
  }

  @HostListener('window:offline', []) onOffline() {
    this.isOnline = false
    this.offlineDialog = this.dialog.open(OfflineDialogComponent, {disableClose: true} as any)
  }

  @HostListener('window:online', []) onOnline() {
    this.isOnline = true
    if (this.offlineDialog) {
      this.offlineDialog.close()
    }
    this.signalRService.reconnect()
  }

  @HostListener('document:visibilitychange', []) onVisibilityChange() {
    if (document.hidden) {
      // application is hidden.
    } else {
      // application is resumed.
      if (this.isOnline) {
        this.signalRService.startConnection()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts